<!-- src/app/shared/components/empty-state/empty-state.component.html -->
<div class="empty-state">
  <i class="bi {{ icon() }} empty-state__icon" aria-hidden="true"></i>
  <div class="empty-state__title">{{ title() }}</div>
  @if (message()) {
    <div class="empty-state__message">{{ message() }}</div>
  }
  <div class="empty-state__actions">
    <ng-content></ng-content>
  </div>
</div>
